import React from 'react';
import { Eye, CheckCircle } from 'lucide-react';
import { CoverageHero } from '../components/CoverageHero';
import { CoverageCTA } from '../components/CoverageCTA';

const Vision = () => {
  return (
    <div className="min-h-screen">
      <CoverageHero
        title="Vision Coverage for Exams, Glasses, Contacts, and Eye Care"
        subtitle="Affordable vision plans to help you see clearly and protect your eye health at every stage of life. Coverage with purpose."
      />
      <section className="py-8">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-6">Why Vision Coverage Matters</h2>
            <p className="text-lg text-gray-700 leading-relaxed">Regular eye exams are important for detecting vision changes and eye health issues early. Vision insurance helps make eye care, glasses, and contacts more affordable.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {[{title:"Eye Exams",desc:"Annual comprehensive eye exams to check your vision and screen for eye diseases."},{title:"Glasses & Frames",desc:"Allowances for prescription lenses and frames that fit your style and budget."},{title:"Contact Lenses",desc:"Coverage for contact lens fittings and supplies, including specialty lenses."}].map(item=>(<div key={item.title} className="bg-white border-t-4 border-brand-blue rounded-lg p-6 shadow-md text-center"><Eye size={32} className="text-brand-blue mx-auto mb-3"/><h3 className="text-xl font-bold text-brand-blue mb-3">{item.title}</h3><p className="text-gray-700">{item.desc}</p></div>))}
          </div>
        </div></div>
      </section>
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-8 text-center">Vision Plans for Everyone</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[{title:"Individual Vision Plans",desc:"Standalone vision coverage for individuals."},{title:"Family Vision Coverage",desc:"Protect your entire family's eye health."},{title:"Senior Vision Options",desc:"Vision coverage tailored for seniors."},{title:"Supplemental Vision",desc:"Add vision benefits to your existing health coverage."}].map(item=>(<div key={item.title} className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-md"><CheckCircle className="text-brand-orange flex-shrink-0 mt-1" size={24}/><div><h3 className="font-bold text-lg text-brand-blue mb-2">{item.title}</h3><p className="text-gray-700">{item.desc}</p></div></div>))}
          </div>
        </div></div>
      </section>
      <CoverageCTA heading="Compare Vision Plans" />
    </div>
  );
};

export default Vision;
